import { createLogger } from '@cko/dashboard-shared';

import { APP_CONFIG } from '../../environment/app';
import { Mfe, Team } from '../../config/shared/enums/mfeTeam';

export const logger = createLogger({
  context: {
    mfe: Mfe.DASHBOARD_APP,
    team: Team.CORE,
    version: APP_CONFIG.version,
  },
});
